import ApiService from 'services/api';

export class AlboUser {

    constructor(data) {
        this.id = data.id;
        this.first_name = data.first_name;
        this.last_name = data.last_name;
        this.attributes = data.attributes;
        this.orders = data.orders || [];
    }

    async getUserOrders() {
        const userOrders = await ApiService.getUserOrders(this.id);
        return userOrders;
    }
}
